import {
  BONUSES_REFUNDED_KEY,
  BONUSES_SPENT_KEY,
  END_DATE_KEY,
  TOTAL_TO_PAY_KEY,
} from '@esentai/core/features/merchantsReconciliationHistory/consts/keys';

import { createDateRangeFilter } from '@/filters/DateRange';
import { createMoneyRangeFilter } from '@/filters/MoneyRange';

export const filterTypes = [
  createDateRangeFilter({
    key: END_DATE_KEY,
    label: 'Дата реконсиляции',
  }),
  createMoneyRangeFilter({
    key: TOTAL_TO_PAY_KEY,
    label: 'Сумма к оплате',
  }),
  createMoneyRangeFilter({
    key: BONUSES_SPENT_KEY,
    label: 'Сумма потраченных бонусов',
  }),
  createMoneyRangeFilter({
    key: BONUSES_REFUNDED_KEY,
    label: 'Сумма бонусов на возврат',
  }),
];
